import { PAGES } from '../lib/config';
import { AI_UPSCALER_FAQ } from '../lib/content';
import { ToolPageShell } from '../components/ToolPageShell';

export function AiImageUpscalerPage() {
  const page = PAGES.find((p) => p.path === '/ai-image-upscaler')!;
  const extra = (
    <>
      <h2 className="text-2xl font-bold text-text-primary">What an AI image upscaler does</h2>
      <p>
        An AI image upscaler reads the existing pixels in your image and predicts the missing detail
        when the image is enlarged. This helps reduce blur and blockiness compared to simple
        resizing.
      </p>
      <p>It is useful for: portraits, product photos, screenshots, logos, and social media graphics.</p>
      <h3 className="text-xl font-semibold text-text-primary">AI vs. regular resizing</h3>
      <p>
        Regular resizing stretches pixels, which can look blurry. AI upscaling tries to reconstruct
        detail so edges stay sharper and textures look more natural.
      </p>
      <p>Supported images: JPG, PNG, WebP. Up to 5MB per file.</p>
    </>
  );
  return <ToolPageShell page={page} faqItems={AI_UPSCALER_FAQ} extraContent={extra} />;
}
